import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './trade-shows.styles.scss';

function NewTradeshowsLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-trade-shows-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-trade-shows-content-component')
  );

  return (
    <div className="trade-shows trade">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewTradeshowsLandingPage;
